import { render, staticRenderFns } from "./delete_event_form.vue?vue&type=template&id=150194a8&"
import script from "./delete_event_form.vue?vue&type=script&lang=js&"
export * from "./delete_event_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports